export const MARK_AS_RMA_REQUEST = "MARK_AS_RMA_REQUEST";
export const MARK_AS_RMA_RESULT = "MARK_AS_RMA_RESULT";
export const MARK_AS_RMA_OPEN_MODAL = "MARK_AS_RMA_OPEN_MODAL";
export const MARK_AS_RMA_CLOSE_MODAL = "MARK_AS_RMA_CLOSE_MODAL";
export const MARK_AS_RMA_GET_DEVICE_REQUEST = "MARK_AS_RMA_GET_DEVICE_REQUEST";
export const MARK_AS_RMA_GET_DEVICE_RESULT = "MARK_AS_RMA_GET_DEVICE_RESULT";

export const MARK_AS_RMA_SET_DEVICE = "MARK_AS_RMA_SET_DEVICE";

